<app-control-layout
    [control]="formCtrl"
    [label]="label"
    [ignoreLabel]="ignoreLabel"
    [permission]="permission"
    [labelBlock]="labelBlock"
    [width]="width"
    [attr.id] ="idName">
    <div class="input-group" [style.width]="labelBlock ? 'calc(100% - 140px)' : '100%'">
        <input class="form-control" placeholder="yyyy-mm-dd"
               name="dp" [formControl]="formCtrl" ngbDatepicker #d="ngbDatepicker" >
        <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button"></button>
      </div>
</app-control-layout>

